import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ErrorLogService {
  private errors: any[] = [];

  logError(error: any) {
    this.errors.push(error);
    if (this.errors.length > 3) {
      this.errors.shift();
    }
  }

  getLastErrors(count: number = 3): any[] {
    return this.errors.slice(-count);
  }
}
